import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BotInfo, BotInfoListItem } from "../../../../shared/_types/bot-info.type";
import { CommandResult } from "../../../../shared/_types/command-result.type";

@Injectable({
    providedIn: "root",
})
export class MarketplaceService {
    constructor(private http: HttpClient) {}

    list(): Observable<BotInfoListItem[]> {
        return this.http.get<BotInfoListItem[]>("/marketplace");
    }

    get(id: string): Observable<BotInfo> {
        return this.http.get<BotInfo>(`/marketplace/${id}`);
    }

    publish(id: string): Observable<BotInfo> {
        return this.http.patch<BotInfo>(`/marketplace/${id}/publish`, {});
    }

    unpublish(id: string): Observable<BotInfo> {
        return this.http.patch<BotInfo>(`/marketplace/${id}/unpublish`, {});
    }

    delete(id: string): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`/marketplace/${id}`);
    }

    create(botInfo: BotInfo): Observable<BotInfo> {
        return this.http.post<BotInfo>("/marketplace", botInfo);
    }

    update(id: string, botInfo: BotInfo): Observable<BotInfo> {
        return this.http.put<BotInfo>(`/marketplace/${id}`, botInfo);
    }
}
